import { createFileRoute } from '@tanstack/react-router'

import { FundRegistry } from '@/components/FundRegistry'

export const Route = createFileRoute('/_app/fund/$id/registry')({
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()
  return <FundRegistry fundId={id} />
}
